import { ValidationMode } from '@wix/ambassador-forms-v1-validation-result/types';
import {
  type ValidationArrayTypeArrayItems,
  type ValidationObjectTypePropertiesType,
  type Validation,
} from '@wix/ambassador-forms-v4-form/types';
import { type SomeJSONSchema } from 'ajv/dist/types/json-schema';

import { mapToArraySchemaProperty } from './array-schema-property-mapper';
import { mapToBooleanSchemaProperty } from './boolean-schema-property-mapper';
import { mapToIntegerSchemaProperty } from './integer-schema-property-mapper';
import { mapToNumberSchemaProperty } from './number-schema-property-mapper';
import { mapToObjectSchemaProperty } from './object-schema-property-mapper';
import { mapToPredefinedSchemaProperty } from './predefined-schema-property-mapper';
import { mapToStringSchemaProperty } from './string-schema-property-mapper';

export type PropertySchemaMapper = typeof propertySchemaMapper;

export function propertySchemaMapper(
  fieldValidation?: Validation &
    ValidationObjectTypePropertiesType &
    ValidationArrayTypeArrayItems,
  target: String | undefined = undefined,
  validationMode: ValidationMode = ValidationMode.UNKNOWN,
  libraryBasedPhoneFieldValidationEnabled: boolean = false,
): Omit<SomeJSONSchema, '$id'> | undefined {
  if (fieldValidation?.string) {
    return mapToStringSchemaProperty(
      fieldValidation.string,
      validationMode,
      libraryBasedPhoneFieldValidationEnabled,
    );
  }

  if (fieldValidation?.stringOptions) {
    return mapToStringSchemaProperty(
      fieldValidation?.stringOptions,
      validationMode,
      libraryBasedPhoneFieldValidationEnabled,
    );
  }

  if (fieldValidation?.number) {
    return mapToNumberSchemaProperty(fieldValidation.number, validationMode);
  }

  if (fieldValidation?.numberOptions) {
    return mapToNumberSchemaProperty(
      fieldValidation.numberOptions,
      validationMode,
    );
  }

  if (fieldValidation?.integer) {
    return mapToIntegerSchemaProperty(fieldValidation.integer, validationMode);
  }

  if (fieldValidation?.boolean) {
    return mapToBooleanSchemaProperty(fieldValidation?.boolean, validationMode);
  }

  if (fieldValidation?.booleanOptions) {
    return mapToBooleanSchemaProperty(
      fieldValidation?.booleanOptions,
      validationMode,
    );
  }

  if (fieldValidation?.array) {
    return mapToArraySchemaProperty(
      fieldValidation.array,
      validationMode,
      libraryBasedPhoneFieldValidationEnabled,
    );
  }

  if (fieldValidation?.arrayOptions) {
    return mapToArraySchemaProperty(
      fieldValidation.arrayOptions,
      validationMode,
      libraryBasedPhoneFieldValidationEnabled,
    );
  }

  if (fieldValidation?.object) {
    return mapToObjectSchemaProperty(fieldValidation.object, validationMode);
  }

  if (fieldValidation?.objectOptions) {
    return mapToObjectSchemaProperty(
      fieldValidation.objectOptions,
      validationMode,
    );
  }

  if (fieldValidation?.predefined) {
    return mapToPredefinedSchemaProperty(
      target,
      fieldValidation.predefined,
      validationMode,
    );
  }

  return undefined;
}
